export default {"src":"/_next/static/media/qoute-open.2bf89c26.svg","height":28,"width":37,"blurWidth":0,"blurHeight":0};